export default "__VITE_ASSET__zHiC$vS$__"